import { createStateContext } from 'admin/helpers'

const [
  AdminCompanyIdProvider,
  useAdminCompanyIdState,
  useAdminCompanyId
] = createStateContext('AdminCompanyId')

export { AdminCompanyIdProvider, useAdminCompanyIdState, useAdminCompanyId }
